module.exports = __webpack_public_path__ + "img/Image_icon.5ee5e02c.svg";